import Mapbox from 'index.vue';
import { BaseFeatureLayer } from './baseFeatureLayer';
import i18n from '../../../main';
export class IsoLinesLayer {
    protected mapboxInstance: InstanceType<typeof Mapbox>;
    protected fillLayer: BaseFeatureLayer;
    protected outlinesLayer: BaseFeatureLayer;


    constructor(mapboxInstance: InstanceType<typeof Mapbox>) {
        this.mapboxInstance = mapboxInstance;
        this.fillLayer = new BaseFeatureLayer(this.mapboxInstance, 'middle', 'isoLines-fill-layer', 'isoLines-fill-source', 'fill', {}, {
            'fill-color': '#d53c00',
            'fill-opacity': 0.2
        }, true);
        this.outlinesLayer = new BaseFeatureLayer(this.mapboxInstance, 'middle', 'isoLines-outlines-layer', 'isoLines-outlines-source', 'line', {}, {
            'line-color': '#d53c00',
            'line-width': 3
        }, true);
        
        
    }

   
    
    public DataChanged = async () => {
        const _self = this;
        let features: any[] = [];
        if (this.mapboxInstance.locationIsoLines) {
            features = this.mapboxInstance.locationIsoLines.features.map((isoLine: any) => {
                // Clone the feature to avoid mutating the original
                const feature = { ...isoLine };

                // Set the title property based on the minutes
                if (feature.properties.minutes != null) {
                    feature.properties.title = `${this.mapboxInstance.isoLineSet.title} ${feature.properties.minutes} ${(i18n.t("message.minutes") as string).toLowerCase() }`;
                } 

                return feature;
            }).filter((isoLine: any) => {
                return isoLine.properties.minutes == null ||
                    (isoLine.properties.minutes == this.mapboxInstance.isoLineMinutes &&
                        isoLine.properties.isoLineSet == this.mapboxInstance.isoLineSet.name);
            });
        }
        //this.fillLayer.SetFeatures(features);
        this.outlinesLayer.SetFeatures(features);
        
    };
}